export const USERS_FOLLOWED_QUERY = `
  query UsersFollowedQuery($userIds: [ID!]!) {
    me {
      usersFollowed(userIds: $userIds) {
        userId
        isFollowed
      }
    }
  }
`;
